import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import raabtaLogo from '@/assets/raabtalogo_white_bg.png';

interface LandingNavProps {
    showMenu?: boolean;
}

export const LandingNav: React.FC<LandingNavProps> = ({ showMenu = true }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>, targetId: string) => {
        if (location.pathname === '/') {
            e.preventDefault();
            const element = document.getElementById(targetId);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
    };

    return (
        <nav className="raabta-nav">
            <div className="raabta-container raabta-nav__inner">
                <Link to="/" className="raabta-brand">
                    <img 
                        src={raabtaLogo} 
                        alt="Raabta Logo" 
                        style={{ height: '30px', width: '30px', borderRadius: '50%', objectFit: 'contain' }} 
                    />
                    <span>Raabta</span>
                </Link>
                {showMenu && (
                    <div className="raabta-nav__links">
                        <Link to="/#features" onClick={(e) => handleLinkClick(e, 'features')}>Features</Link>
                        <Link to="/#workflow" onClick={(e) => handleLinkClick(e, 'workflow')}>Workflow</Link>
                        {location.pathname !== '/contact' && <Link to="/contact">Contact Us</Link>}
                    </div>
                )}
                <div className="raabta-nav__actions">
                    {/* <button className="raabta-btn raabta-btn--ghost" onClick={() => navigate('/login')}>Log in</button> */}
                    {location.pathname !== '/contact' && (
                        <button className="raabta-btn raabta-btn--primary" onClick={() => navigate('/contact')}>
                            Get Started <ArrowRight size={14} />
                        </button>
                    )}
                </div>
            </div>
        </nav>
    );
};
